import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal, Offcanvas } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
import axiosInstance from "../../../../services/api/API";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import moment from "moment";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import AddIssueDynemicForm from "../../addIssueDynemicFrom";
//plus-circle.svg Minus-circle.svg

const estimateTime = [
  {
    label: "1:00:00",
    value: "01:00:00",
  },

  {
    label: "2:00:00",
    value: "02:00:00",
  },
  {
    label: "3:00:00",
    value: "03:00:00",
  },
  {
    label: "4:00:00",
    value: "04:00:00",
  },
  {
    label: "5:00:00",
    value: "05:00:00",
  },
  {
    label: "6:00:00",
    value: "06:00:00",
  },
  {
    label: "7:00:00",
    value: "07:00:00",
  },
  {
    label: "8:00:00",
    value: "08:00:00",
  },
  {
    label: "9:00:00",
    value:"09:00:00",
  },
  {
    label: "10:00:00",
    value: "10:00:00",
  },
];

const SuperVisorDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  const navigate = useNavigate();
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const [formData, setFormData] = useState({ solve: 1 });
  const token = localStorage.getItem("authToken");
  const [validationErrors, setValidationErrors] = useState({});
  const [serviceModel, setServiceModel] = useState(false);
  const [complainList, setComplainList] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);
  const [repair, setRepair] = useState([]);
  const [addModel, setAddModel] = useState(false);
  const [editIssueData, setEditIssueData] = useState();
  const bussness_id = data?.business_partner_id;
  const job_card_id = data?.job_card_id;
  const [eastTime,setEastTime]=useState(estimateTime)

  const businessPartnerId = localStorage.getItem("business_partner_id")
  console.log(businessPartnerId, "businesspartnerid")

  const [assigneeList] = useState([
    { name: "Telecaller 1", assignedLeads: 5 },
    { name: "Telecaller 2", assignedLeads: 10 },
    { name: "Telecaller 3", assignedLeads: 3 },
    { name: "Sales Manager 1", assignedLeads: 8 },
    { name: "Sales Manager 2", assignedLeads: 6 },
    { name: "Sales Manager 3", assignedLeads: 2 },
  ]);
  const [issueId, setIssueId] = useState(0);

  const IssueInputs = [
    {
      name: "Complain",
      label: "Complain",
      type: "dropdown",
      required: true,
      // options: options,
      options: complainList || [],
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "Complain_Description",
      label: "Complain Description",
      placeholder: "Enter Complain Description ",
      type: "text",
      required: true,
      gridClass: "col-lg-12",
      validation: {
        required: true,
        maxLength: 50,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
      },
    },

    {
      name: "estimated_cost",
      label: "Estimate Cost",
      type: "number",
      placeholder: "Enter Estimate Cost ",
      required: true,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "technician",
      label: "Technician",
      type: "dropdown",
      required: true,
   
      options: technicianList || [],
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      required: true,
      gridClass: "col-lg-12",
      validation: {
        required: true,
        maxLength: 50,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "issue_status",
      label: "Issue Status",
      type: "dropdown",
      options: [
        { label: "Pending", value: 0 },
        { label: "Done", value: 1 },
      ],
      // required: false,
      gridClass: "col-lg-12",
      // validation: { required: false },
    },
    {
      name: "repair",
      label: "Repair",
      type: "dropdown",
      options: repair || [],
      required: true,
      gridClass: "col-lg-12",
      validation: { required: true },
      dropdownOptionsListPosition: "top",
      
    },
    {
      name: "east_time",
      label: "Estimate Time",
      placeholder: "Enter Estimate Time ",
      type: "dropdown",
      options: eastTime || [],
      required: true,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
  ];

  const servicesData = [
    {
      name: "solve",
      label: "Solve",
      type: "toggle",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "labour_charges",
      label: "Labour Charges",
      type: "number",
      placeholder: "Enter Labour Charges",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/jobcardview",
        {
          business_partner_id: data?.business_partner_id ?data?.business_partner_id: 1,
          job_card_id: data?.job_card_id,
          login_user_id: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        ...item,
        //"Sr_No": index + 1,
        //:item?.solved === 0 ? 'Pending': 'Done',
        // job_card_no:onClickNavigetion(item)
      }));

      setJobCardDetails(formattedData[0]);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getservicesdetails",
        {
          business_partner_id: data?.business_partner_id || businessPartnerId==0?1:0,
          job_card_id: data?.job_card_id,
          login_user_id: null,
          Type: "SuperviserComplainView",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response.data.data.map((item, index) => ({
        ...item,
        //"Sr_No": index + 1,
        //:item?.solved === 0 ? 'Pending': 'Done',
        // job_card_no:onClickNavigetion(item)
      }));
      setJobCardIssueList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const onClickSetIssueId = (id) => {
    if (id == "") {
      setIssueId("");
    } else {
      setIssueId(id);
    }
  };

  const JobCardClose = async (data) => {
    const errors = {};
    let isValid = true;
    servicesData.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    try {
      const response = await axiosInstance.post(
        "/supervisertodo/jobcardclose",
        {
          business_partner_id: bussness_id || businessPartnerId==0?1:businessPartnerId,
          job_card_id: job_card_id,
          labour_charges: data?.labour_charges,
          solved: data?.solve ? 1 : 0,
          solved_remarks: data?.remark,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setServiceModel(false);
      navigate("/manage-services/supervisor-to-do");
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchComplainList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Complain",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchTecnicianList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Technician",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setTechnicianList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchRepairList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id: businessPartnerId==0?1:businessPartnerId,
          FilterId: null,
          FilterString: null,
          Type: "Repair",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        label: item?.name,
        value: item?.id,
        // status: item?.solved === 0 ? 'Pending' : 'Done',
        // job_card_no: onClickNavigetion(item)
      }));
      setRepair(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    // const errors = {};
    // let isValid = true;
    // IssueInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     }
    //   }
    // });
    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    if (editIssueData?.comp_id) {
      try {
        const response = await axiosInstance.post(
          "/jobcardcomplain/jobcardcomplainupdate",
          {
            business_partner_id:businessPartnerId==0?1:businessPartnerId ,

            job_card_id: editIssueData?.job_card_id || null,
            comp_id: editIssueData?.comp_id,
            complain_id: data?.Complain || null,
            complain_desc: data?.Complain_Description || null,
            estcost: data?.estimated_cost || null,
            technician_id: data?.technician || null,
            remark: data?.remark || null,
            issue_status: data?.issue_status,
            esttime: data?.east_time || null,
            tech_remark: null,
            actual_time: null,
            repair_id: data?.repair || null,
            status: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("response", response);
        if (response?.status) {
          setEditIssueData(null);
          setFormData({ issue_status: 0 });
          setAddModel(false);
          fetchJobCardIssueList();
          fetchJobCardDetails();
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    } else {
      try {
        const response = await axiosInstance.post(
          "/jobcardcomplain/create",
          {
            business_partner_id:businessPartnerId==0?1:businessPartnerId ,

            job_card_id: job_card_id || null,
            complain_id: data?.Complain || null,
            complain_desc: data?.Complain_Description || null,
            estcost: data?.estimated_cost || null,
            technician_id: data?.technician || null,
            remark: data?.remark || null,
            issue_status: data?.issue_status,
            esttime: data?.east_time || null,
            tech_remark: null,
            actual_time: null,
            repair_id: data?.repair || null,
            status: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status) {
          setAddModel(false);
          fetchJobCardIssueList();
          fetchJobCardDetails();
        }
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };

  const handleClose = () => {
     setEditIssueData(null);
    setFormData({ issue_status: 0 });
    setAddModel(!addModel);
  };

  useEffect(() => {
    fetchComplainList();
    fetchTecnicianList();
    fetchRepairList();
  }, []);

  useEffect(() => {
    if (data) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
    }
  }, []);

  const editOpenData = (issueDetails) => {
    setEditIssueData(issueDetails);
    if (issueDetails?.comp_id) {
      setFormData({
        Complain: issueDetails?.complain_id,
        Complain_Description: issueDetails?.complain_desc,
        estimated_cost: issueDetails?.estcost,
        remark: issueDetails?.remark,
        issue_status: issueDetails?.issue_status,
        east_time: issueDetails?.esttime ,
        repair: issueDetails?.repair_id,
        technician: issueDetails?.technician_id,
      });
    }
    setAddModel(true);
  };
  
  const backNavigate = () => {
    navigate("/manage-services/supervisor-to-do");
  };

  return (
    <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 ">
        <span className="backbtntitle">
          {" "}
          <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>backNavigate()}/>{" "}
          Supervisor To Do Details
        </span>
        {jobCardDetails?.allissue_resolve == 1 && (
          <button
            className="addcustomerbutton"
            onClick={() => setServiceModel(true)}
          >
            Complete Job Card
          </button>
        )}
      </div>
      <div className="container-fuiled row   ">
        <div className="col-5 vechalDetails">
          <h5 className="m-3">Vehicle Details</h5>
          <div className="vechal-Details-SubView m-3">
            <div className="details-item">
              <span className="details-label">Job Card No.</span>
              <span className="details-value">
                {jobCardDetails?.job_card_no || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Job Card Date</span>
              <span className="details-value">
                {moment(jobCardDetails?.transaction_date).format("DD/MM/YYYY")}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Customer Name</span>
              <span className="details-value">
                {jobCardDetails?.customer_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Mobile No.</span>
              <span className="details-value">
                {jobCardDetails?.contact_no || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Reg. No.</span>
              <span className="details-value">
                {jobCardDetails?.registration_no || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Chassis No.</span>
              <span className="details-value">
                {jobCardDetails?.chassis_no || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Engine No.</span>
              <span className="details-value">
                {jobCardDetails?.engineno || "-"}
              </span>
            </div>
            {/* <div className="details-item">
              <span className="details-label">PIN Code</span>
              <span className="details-value">
                {jobCardDetails?.pincode || "-"}
              </span>
            </div> */}

            <div className="details-item">
              <span className="details-label">Product Name</span>
              <span className="details-value">
                {jobCardDetails?.product_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Sub Product Name</span>
              <span className="details-value">
                {jobCardDetails?.subproduct_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Make</span>
              <span className="details-value">
                {jobCardDetails?.make_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Model</span>
              <span className="details-value">
                {jobCardDetails?.model_name || "-"}{" "}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Variant</span>
              <span className="details-value">
                {jobCardDetails?.variant_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Variant Color</span>
              <span className="details-value">
                {jobCardDetails?.color_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Fuel Type</span>
              <span className="details-value">
                {jobCardDetails?.fuel_type_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Warranty Start Date</span>
              <span className="details-value">
                {moment(jobCardDetails?.warranty_startdate).format('DD/MM/YYYY') || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Warranty End Date</span>
              <span className="details-value">
                {moment(jobCardDetails?.warranty_enddate).format('DD/MM/YYYY') || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Warranty Period</span>
              <span className="details-value">
                {jobCardDetails?.warranty_period || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Supervisor</span>
              <span className="details-value">
                {jobCardDetails?.supervisor_name || "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Allocation Date</span>
              <span className="details-value">
                {moment(jobCardDetails?.allocation_date).format("DD/MM/YYYY") ||
                  "-"}
              </span>
            </div>
            <div className="details-item">
              <span className="details-label">Job Estimate Amt.</span>
              <span className="details-value">
                {jobCardDetails?.job_estimate_amount || 0}
              </span>
            </div>

            <div className="details-item">
              <span className="details-label">Job Status</span>
              <span className="details-value">
                {jobCardDetails?.status == 0 ? "Pending" : "Done"}
              </span>
            </div>
            {/* <div className="details-item">
              <span className="details-label">Complain</span>
              <span className="details-value">{jobCardDetails?.complaint}</span>
            </div> */}
            <div className="details-item">
              <span className="details-label">Signature</span>
              <div style={{ display: "flex", gap: 5 }}>
                <img
                  src={jobCardDetails?.signature_path}
                  style={{ height: 30, width: 50 }}
                />
                <span className="details-value">Verify</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-7">
          <div className="addButtonStyle m-2">
            <h5>Issue Details</h5>
            <button
              className="addcustomerbutton"
              onClick={() => setAddModel(true)}
            >
              Add Issue
            </button>
          </div>
          <div className="issue-list-parent-container">
            {(jobCardIssueList || [])?.map((issueDetails) => (
              <div className="issue-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Complain</span>
                  <span className="details-value">
                    {issueDetails?.complain || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Technician Name</span>
                  <span className="details-value">
                    {issueDetails?.technician_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Complain Description</span>
                  <span className="details-value">
                    {issueDetails?.complain_desc || "-"}
                  </span>
                </div>

                <div className="d-flex gap-5 pl-8 ">
                  <>
                    <div
                      onClick={() => {
                        editOpenData(issueDetails);
                      }}
                    >
                      <img
                        src={editIcon}
                        // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                        className="accordion-icon "
                        style={{ height: 20, width: 20 }}
                      />
                    </div>
                    {issueDetails?.comp_id === issueId ? (
                      <div
                        onClick={() => {
                          onClickSetIssueId("");
                        }}
                      >
                        <img
                          src={MinusIcon}
                          //   alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                          className="accordion-icon"
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          onClickSetIssueId(issueDetails?.comp_id);
                        }}
                      >
                        <img
                          src={plusIcon}
                          // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                          className="accordion-icon"
                          style={{ height: 20, width: 20 }}
                        />
                      </div>
                    )}
                  </>
                </div>
                {issueDetails?.comp_id === issueId && (
                  <>
                    <div className="details-item">
                      <span className="details-label">Work Shop</span>
                      <span className="details-value">
                        {issueDetails?.WorkShop || "-"}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="details-label">Estimate Cost</span>
                      <span className="details-value">
                        {issueDetails?.estcost || 0}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="details-label">Estimate Time</span>
                      <span className="details-value">
                        {issueDetails?.esttime || 0}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="details-label">Issue Status</span>
                      <span className="details-value">
                        {issueDetails?.issue_status == 1 ? "Done" : "Pending"}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="details-label">Remark</span>
                      <span className="details-value">
                        {issueDetails?.remark || "-"}
                      </span>
                    </div>
                    {/* <div className="details-item">
                        <span className="details-label">Part:</span>
                        <span className="details-value">
                          {issueDetails?.part || "-"}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="details-label">Part Type:</span>
                        <span className="details-value">
                          {issueDetails?.PartType || "-"}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="details-label">Issue:</span>
                        <span className="details-value">
                          {issueDetails?.remark || "-"}{" "}
                        </span>
                      </div>

                      <div className="details-item">
                        <span className="details-label">Item Name:</span>
                        <span className="details-value">
                          {issueDetails?.itemName}
                        </span>
                      </div>
                      <div className="details-item">
                        <span className="details-label">Goods Qty:</span>
                        <span className="details-value">
                          {issueDetails?.GoodsQty}
                        </span>
                      </div> */}
                    <div className="details-item">
                      <span className="details-label">Repair Status:</span>
                      <span className="details-value">
                        {issueDetails?.RepairStatus}
                      </span>
                    </div>
                    {/* <div className="totalvaluescontainer col-xl-8 col-lg-12 ">
                     
                      <button
                        className="addcustomerbutton"
                        onClick={() =>
                          navigate("add-job-card-issue", {
                            state: {
                              jobCarddata: JSON.parse(
                                JSON.stringify(issueDetails)
                              ),
                            },
                          })
                        }
                      >
                        Edit
                      </button>
                    </div> */}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {serviceModel && (
        <Modal
          show={serviceModel}
          onHide={() => setServiceModel(false)}
          centered
          size="lg"
          //  className="large"
        >
          <Modal.Header closeButton>
            <Modal.Title>Job Card Close</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DynamicForm
              formConfig={servicesData || []}
              formData={formData}
              setFormData={setFormData}
              onSubmit={JobCardClose}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              // setShowParentDesignation={setShowParentDesignation}
            />
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  JobCardClose(formData);
                }}
                className="submit-btn"
              >
                {"Submit"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <Offcanvas placement={"end"} show={addModel} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
           
             {editIssueData?.comp_id ? "Edit Issue" : "Add Issue"} 
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="">
            <AddIssueDynemicForm
              formConfig={IssueInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />

            <div className="col-12 ">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn w-100"
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SuperVisorDetails;
